import { IconButtonSize } from './types';
import rootClasses from './styles/root.module.scss';

export function getButtonSizeClass(size: IconButtonSize) {
	switch (size) {
		case 'tiny':
			return rootClasses.root_tiny;
		case 'small':
			return rootClasses.root_small;
		case 'normal':
			return rootClasses.root_normal;
		case 'medium':
			return rootClasses.root_medium;

		default:
			return rootClasses.root_none;
	}
}

export function getIconSizeConst(size: IconButtonSize) {
	switch (size) {
		case 'tiny':
			return 12;
		case 'small':
			return 14;
		case 'normal':
			return 16;
		case 'medium':
			return 22;

		default:
			return 16;
	}
}
